// ======================================================================
// FILE: src/modules/campaign/routes/CampaignRoutes.js
// MODULE: Campaign Management
// PURPOSE:
//   Route configuration for Campaign module
// ======================================================================

import React from "react";

import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import CampaignLayout
from "../CampaignLayout";

// ======================================================================
// DASHBOARD
// ======================================================================

import CampaignDashboardPage
from "../dashboard/pages/CampaignDashboardPage";

// ======================================================================
// PROSPECT IMPORT
// ======================================================================

import ProspectImportPage
from "../prospectImport/pages/ProspectImportPage";

// ======================================================================
// ROUTES
// ======================================================================

export default function CampaignRoutes() {

  return (

    <CampaignLayout>

      <Routes>

        {/* ========================================================= */}
        {/* DEFAULT */}
        {/* ========================================================= */}

        <Route
          path="/"
          element={
            <Navigate
              to="dashboard"
              replace
            />
          }
        />

        {/* ========================================================= */}
        {/* DASHBOARD */}
        {/* ========================================================= */}

        <Route
          path="dashboard"
          element={
            <CampaignDashboardPage />
          }
        />

        {/* ========================================================= */}
        {/* PROSPECT IMPORT */}
        {/* ========================================================= */}

        <Route
          path="prospect-import"
          element={
            <ProspectImportPage />
          }
        />

        {/* ========================================================= */}
        {/* FALLBACK */}
        {/* ========================================================= */}

        <Route
          path="*"
          element={
            <Navigate
              to="/campaign/dashboard"
              replace
            />
          }
        />

      </Routes>

    </CampaignLayout>

  );

}